import { DELETE_CATEGORY_SUCCESS } from '../categories/constants';
import {
  GET_USER_BY_COGNITO_ID,
  GET_USER_BY_COGNITO_ID_SUCCESS,
  GET_USER_BY_COGNITO_ID_FAILED,
  RESET_USER_STATE,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILED,
  GET_TAGS,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  UPLOAD_PROFILE_PICTURE,
  UPLOAD_PROFILE_PICTURE_SUCCESS,
  UPLOAD_PROFILE_PICTURE_FAILED,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  GET_REGISTERED_VENUE_OWNERS,
  GET_REGISTERED_VENUE_OWNERS_SUCCESS,
  GET_REGISTERED_VENUE_OWNERS_FAILED,
  GET_USERS_RATING_BY_ROLE,
  GET_USERS_RATING_BY_ROLE_FAILED,
  GET_USERS_RATING_BY_ROLE_SUCCESS,
  DELETE_USER_RATING_FAILED,
  DELETE_USER_RATING_SUCCESS,
  DELETE_USER_RATING,
  GET_VENDOR_USERS,
  GET_VENDOR_USERS_SUCCESS,
  GET_VENDOR_USERS_FAILED,
  ON_SEARCH_VENDOR_USER,
  GET_USERS_VENUE_VENDORS_FAILED,
  GET_USERS_VENUE_VENDORS_SUCCESS,
  GET_USERS_VENUE_VENDORS,
  ON_SEARCH_USERS,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS,
  DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED,
  GET_VENDORS_BY_VENUE,
  GET_VENDORS_BY_VENUE_SUCCESS,
  GET_VENDORS_BY_VENUE_FAILED,
  CREATE_USER_ASSET,
  CREATE_USER_ASSET_SUCCESS,
  CREATE_USER_ASSET_FAILED,
  DELETE_USER_ASSET,
  DELETE_USER_ASSET_SUCCESS,
  DELETE_USER_ASSET_FAILED,
  UPDATE_USER_ASSET,
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAILED,
} from './constants';

const getCurrentUserStorage = () => {
  const itemStr = localStorage.getItem('user');
  return itemStr ? JSON.parse(localStorage.getItem('user')) : undefined;
};

const initialState = {
  user: getCurrentUserStorage(),
  usersList: [],
  vendorUsersFilteredList: [],
  error: null,
  loading: false,
  assets: [],
  vendorUser: {},
};

const userReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_USER_BY_COGNITO_ID:
      return { ...state, loading: true };
    case GET_USER_BY_COGNITO_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
      };
    case GET_USER_BY_COGNITO_ID_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case RESET_USER_STATE:
      return {
        ...state,
        user: undefined,
      };
    case GET_TAGS:
    case GET_USERS_RATING_BY_ROLE:
      return { ...state, loading: true };
    case GET_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tagsList: action.payload.tagsList,
      };
    case EDIT_USER:
    case DELETE_USER_RATING:
      return { ...state, loading: true };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userEdited: action.payload.user,
      };
    case EDIT_USER_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case UPLOAD_PROFILE_PICTURE:
      return { ...state, loading: true };
    case UPLOAD_PROFILE_PICTURE_SUCCESS:
      return {
        ...state,
        loading: false,
        imgUpdated: action.payload,
      };
    case UPLOAD_PROFILE_PICTURE_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case GET_USERS:
    case GET_REGISTERED_VENUE_OWNERS:
    case DISABLE_USER_BY_TERMS_ANDS_CONDITIONS:
    case GET_USERS_VENUE_VENDORS:
    case GET_VENDORS_BY_VENUE:
      return { ...state, loading: true };
    case GET_USERS_SUCCESS:
    case GET_REGISTERED_VENUE_OWNERS_SUCCESS:
    case GET_USERS_VENUE_VENDORS_SUCCESS:
    case GET_VENDORS_BY_VENUE_SUCCESS:
      return { ...state, usersList: action.payload.users, loading: false };
    case GET_USERS_FAILED:
    case GET_REGISTERED_VENUE_OWNERS_FAILED:
    case GET_TAGS_FAILED:
    case GET_USERS_RATING_BY_ROLE_FAILED:
    case DELETE_USER_RATING_FAILED:
    case GET_USERS_VENUE_VENDORS_FAILED:
    case GET_VENDORS_BY_VENUE_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case GET_USERS_RATING_BY_ROLE_SUCCESS:
      return { ...state, ratings: action.payload.ratings, loading: false };
    case DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_SUCCESS: {
      const { userId } = action.payload;
      return {
        ...state,
        loading: false,
        usersVendorList: state.usersVendorList.map((user) =>
          user.id === userId ? { ...user, state: 'INACTIVE' } : user,
        ),
      };
    }
    case DELETE_USER_RATING_SUCCESS:
      return { ...state, loading: false };
    case GET_VENDOR_USERS:
      return { ...state, loading: true };
    case GET_VENDOR_USERS_SUCCESS:
      return { ...state, usersVendorList: action.payload.users, loading: false };
    case DISABLE_USER_BY_TERMS_ANDS_CONDITIONS_FAILED:
    case GET_VENDOR_USERS_FAILED:
      return { ...state, error: action.payload.error, loading: false };

    case ON_SEARCH_VENDOR_USER: {
      const { text } = action.payload;
      const vendorUsersFilteredList = [];
      state.usersVendorList?.forEach((item) => {
        const name = item?.name.toLowerCase();
        if (name?.search(text?.toLowerCase()) !== -1) vendorUsersFilteredList.push(item);
      });
      return { ...state, vendorUsersFilteredList };
    }
    case ON_SEARCH_USERS: {
      const { text } = action.payload;
      const usersFilteredList = [];
      let cond;
      const getRoleText = (item) => {
        const candidate =
          item?.role?.name ??
          item?.role ??
          item?.group?.name ??
          item?.group ??
          item?.role_name ??
          item?.group_name ??
          item?.roleName;
        if (typeof candidate === 'string') return candidate.toLowerCase();
        if (candidate && typeof candidate === 'object') {
          if (candidate.name) return String(candidate.name).toLowerCase();
          if (candidate.id) return String(candidate.id).toLowerCase();
        }
        return '';
      };
      state.usersList.forEach((item) => {
        const name = `{${item?.name.toLowerCase()} ${item?.last_name.toLowerCase()}}`;
        const email = item?.email.toLowerCase();
        const phone = item?.phone_number?.toLowerCase();
        const role = getRoleText(item);
        if (phone) {
          cond =
            name.search(text.toLowerCase()) !== -1 ||
            email.search(text.toLowerCase()) !== -1 ||
            phone?.search(text.toLowerCase()) !== -1 ||
            role?.search(text.toLowerCase()) !== -1;
        } else {
          cond =
            name.search(text.toLowerCase()) !== -1 ||
            email.search(text.toLowerCase()) !== -1 ||
            role?.search(text.toLowerCase()) !== -1;
        }

        if (cond) {
          usersFilteredList.push(item);
        }
      });
      return { ...state, usersFilteredList };
    }
    case CREATE_USER_ASSET:
      return { ...state, loading: true };
    case CREATE_USER_ASSET_SUCCESS:
      return {
        ...state,
        user: { ...state.user, assets: [...state.user.assets, action.payload.userAsset] },
        loading: false,
      };
    case CREATE_USER_ASSET_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case DELETE_USER_ASSET:
      return { ...state, loading: true };
    case DELETE_USER_ASSET_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          assets: [...state.user.assets.filter(({ id }) => id !== action.payload.userAsset)],
        },
        loading: false,
      };
    case DELETE_USER_ASSET_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case UPDATE_USER_ASSET:
      return { ...state, loading: false };
    case GET_USER_BY_ID:
      return { ...state, loading: true };
    case GET_USER_BY_ID_SUCCESS:
      return { ...state, vendorUser: action.payload.userById, loading: false };
    case GET_USER_BY_ID_FAILED:
      return { ...state, error: action.payload.error, loading: false };

    default:
      return state;
  }
};

export default userReducer;
